import React from 'react';
import { Asset } from '../../../types/assets';
import { Card, Container, Grid, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatCurrency } from '../../../utils/helpers';
import moment from 'moment';

interface props {
  asset: Asset;
}

const CompanyDetails = ({ asset }: props) => {
  const isSmallScreen = useMediaQuery('(max-width: 800px)');
  return (
    <Container maxWidth={'xl'}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={8}
          sx={{ marginBottom: '20px', padding: '40px' }}
        ></Grid>

        <Grid item xs={12} md={4} style={{ position: 'relative' }}>
          <Card
            sx={{
              borderRadius: '10px',
              position: !isSmallScreen ? 'absolute' : 'relative',
              top: '-30px',
              width: '95%',
            }}
          >
            <Typography
              sx={{
                padding: '20px',
                fontWeight: 'bold',
              }}
            >
              Investment Info
            </Typography>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Round</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.round || '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Investor Type</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.company?.investorType === 'Other Please state'
                    ? asset?.company?.otherInvestorType
                    : asset?.company?.investorType || '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>
                  Raise Target (
                  {asset?.investmentInfo?.currency
                    ? asset?.investmentInfo?.currency
                    : 'AUD'}
                  )
                </p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.raiseTarget
                    ? formatCurrency(asset?.investmentInfo?.raiseTarget)
                    : '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Raise Close</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.raiseClose
                    ? moment(asset?.investmentInfo?.raiseClose).format(
                        'DD-MM-YYYY'
                      )
                    : '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>
                  Min Investment (
                  {asset?.investmentInfo?.currency
                    ? asset?.investmentInfo?.currency
                    : 'AUD'}
                  )
                </p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.minimumInvestment
                    ? formatCurrency(asset?.investmentInfo?.minimumInvestment)
                    : '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>
                  Pre Money Valuation (
                  {asset?.investmentInfo?.currency
                    ? asset?.investmentInfo?.currency
                    : 'AUD'}
                  )
                </p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.preMoneyVal
                    ? formatCurrency(asset?.investmentInfo?.preMoneyVal)
                    : '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Security Type</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.preMoneyValRational || '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Asset Type</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.assetType || '-'}
                </p>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>
                  Revenue (
                  {asset?.investmentInfo?.currency
                    ? asset?.investmentInfo?.currency
                    : 'AUD'}
                  )
                </p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.revenue
                    ? formatCurrency(asset?.investmentInfo?.revenue)
                    : '-'}
                </p>
              </Grid>
            </Grid>

            {/* <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Locations</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.locations || '-'}
                </p>
              </Grid>
            </Grid> */}

            {/* <Grid
              container
              justifyContent={'space-between'}
              spacing={2}
              sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
            >
              <Grid item>
                <p>Use Of funds</p>
              </Grid>
              <Grid item>
                <p style={{ fontWeight: 'bold' }}>
                  {asset?.investmentInfo?.useOfFunds || '-'}
                </p>
              </Grid>
            </Grid> */}
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CompanyDetails;
